/**
 * The PositionManager owns positions for every node EXCEPT lane containers:
 * lane positions are derived exclusively by `applyLaneLayout`, and lanes
 * never have a saved entry — resolving one lands on the adapter's sentinel,
 * which `childBasePosition` then folds into every child's base, shifting the
 * whole lane content (the drag-release X-jump regression). Every surface
 * that resolves, seeds, or persists through the manager must exclude lanes
 * via these helpers rather than re-asserting the predicate inline.
 */ export function isManagedNode(node, isLane) {
    return !(isLane?.(node) ?? false);
}
/** The subset of `nodes` the PositionManager is allowed to touch. */ export function managedNodes(nodes, isLane) {
    return isLane ? nodes.filter((n)=>isManagedNode(n, isLane)) : nodes;
}

//# sourceMappingURL=managedNodes.js.map